import { getToken, setToken } from "@/lib/api";

const BK_TOKEN = "admin_token_backup";
const BK_USER = "admin_user_backup";
const IMP_NAME = "impersonating_tenant";

export const isImpersonating = () => !!localStorage.getItem(BK_TOKEN);
export const impersonatingName = () => localStorage.getItem(IMP_NAME) || "";

export const startImpersonation = ({ token, user, tenant_name }) => {
  if (!isImpersonating()) {
    localStorage.setItem(BK_TOKEN, getToken() || "");
    localStorage.setItem(BK_USER, localStorage.getItem("user") || "");
  }
  localStorage.setItem(IMP_NAME, tenant_name || "");
  setToken(token);
  localStorage.setItem("user", JSON.stringify(user));
  window.location.assign("/");
};

export const stopImpersonation = () => {
  const t = localStorage.getItem(BK_TOKEN);
  const u = localStorage.getItem(BK_USER);
  [BK_TOKEN, BK_USER, IMP_NAME].forEach((k) => localStorage.removeItem(k));
  setToken(t || null);
  if (u) localStorage.setItem("user", u); else localStorage.removeItem("user");
  window.location.assign(t ? "/franquias" : "/login");
};
